import * as React from "react";
import * as ReactDOM from "react-dom/client";
import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
} from "react-router-dom";
import "./index.css";
import Layout from "./Layout";
import App from "./App";
import Dashboard from "./pages/Admin/Dashboard/Dashboard";
import Supplier from "./pages/Admin/Supplier/Supplier";
import Ledger from "./pages/Admin/Ledger/Ledger";
import NotFound from "./pages/NotFound";
import Customers from "./pages/Admin/Customers/Customers";
import Payment from "./pages/Admin/Payment/Payment";
import Products from "./pages/Admin/Products/Products";
import Expense from "./pages/Admin/Expense/Expense";
import Loan from "./pages/Admin/Loan/Loan";
import LoanDetail from "./pages/Admin/Loan/LoanDetail";
import Labour from "./pages/Admin/Labour/Labour";
import Report from "./pages/Admin/Report/Report";
import DailyReport from "./pages/Admin/Report/DailyReport";
import DailyReportDetail from "./pages/Admin/Report/DailyReportDetail";
import Calculator from "./pages/Admin/Calculator/Calculator";
import RawMaterial from "./pages/Admin/RawMaterial/RawMaterial";
import { Toaster } from "react-hot-toast";
import { store } from "./store/store";
import { Provider } from "react-redux";
import CreateInvoice from "./pages/Admin/Customers/CreateInvoice";
import EditInvoice from "./pages/Admin/Customers/EditInvoice";
import EditReturn from "./pages/Admin/Customers/EditReturn";
import StockStats from "./pages/Admin/Products/StockStats";
import SupplierCreateInvoice from "./pages/Admin/Supplier/SupplierCreateInvoice";
import CustomerViewInvoice from "./pages/Admin/Customers/CustomerViewInvoice";
import Auth from "./pages/Auth/Auth";
import RMStockStat from "./pages/Admin/RawMaterial/RMStockStat";
import Investors from "./pages/Admin/Investors/Investors";
import Investments from "./pages/Admin/Investors/Investments";
import Categories from "./pages/Admin/Products/Categories";
import SubCategories from "./pages/Admin/Products/SubCategories";
import Invoices from "./pages/Admin/Invoices/Invoices";
import CustomerPayments from "./pages/Admin/Payment/CustomerPayments";
import CompanyPayments from "./pages/Admin/Payment/CompanyPayments";
import Accounts from "./pages/Admin/Accounts/Accounts";
import AccountTransactionLog from "./pages/Admin/Accounts/AccountTransactionLog";
import CashPayments from "./pages/Admin/CashPayments/CashPayments";
import Finance from "./pages/Admin/Finance/Finance";
import NewBillInvoice from "./components/Reports/NewBillInvoice";
import CompanyReport from "./components/Reports/CompanyReport";
import ItemReport from "./components/Reports/ItemReport";
import CustomersReport from "./components/Reports/CustomersReport";
import CustomersLegderReport from "./components/Reports/CustomersLegderReport";
import CompanyLegderReport from "./components/Reports/CompanyLegderReport";
import Branches from "./pages/Admin/Branches/Branches";
import CustomersItemSummaryReport from "./components/Reports/CustomersItemSummaryReport";
import CompanyItemSummaryReport from "./components/Reports/CompanyItemSummaryReport";
import ItemSummary from "./pages/Admin/Products/ItemSummary";
import AddMultipleStock from "./pages/Admin/Invoices/AddMultipleStock";
import DiscountLogPage from "./pages/Admin/DiscountLog/DiscountLogPage";
import StockQtyAdjustmentReport from "./pages/Admin/Products/StockQtyAdjustmentReport";
import Receivables from "./pages/Admin/Receivables/Receivables";
import ReceivableDetail from "./pages/Admin/Receivables/ReceivableDetail";
import Payables from "./pages/Admin/Payables/Payables";
import PayableDetail from "./pages/Admin/Payables/PayableDetail";
import LoanAccountUsers from "./pages/Admin/LoanAccounts/LoanAccountUsers";
import LoanPartyPortal from "./pages/LoanAccount/LoanPartyPortal";
import { getSessionRole } from "./utils/auth";

const sessionRole = getSessionRole();

const router = createBrowserRouter(
  sessionRole === 0 || sessionRole === 1
    ? [
        {
          path: "/admin",
          element: <Layout />,
          children: [
            { path: "", element: <Dashboard /> },
            { path: "companies", element: <Supplier /> },
            { path: "ledger", element: <Ledger /> },
            { path: "customers", element: <Customers /> },
            { path: "receivables", element: <Receivables /> },
            { path: "receivables/:customerId", element: <ReceivableDetail /> },
            { path: "payables", element: <Payables /> },
            { path: "payables/:companyId", element: <PayableDetail /> },
            { path: "cash-payments", element: <CashPayments /> },
            { path: "finance", element: <Finance /> },
            { path: "customers-invoice", element: <CreateInvoice /> },
            { path: "edit-customers-invoice", element: <EditInvoice /> },
            {
              path: "edit-customers-invoice/:invoiceId",
              element: <EditInvoice />,
            },
            { path: "edit-customers-return", element: <EditReturn /> },
            {
              path: "edit-customers-return/:returnId",
              element: <EditReturn />,
            },
            { path: "customers-payments/:id", element: <CustomerPayments /> },
            { path: "company-payments/:id", element: <CompanyPayments /> },
            {
              path: "view-customers-invoice",
              element: <CustomerViewInvoice />,
            },
            { path: "supplier-invoice", element: <SupplierCreateInvoice /> },
            { path: "payments", element: <Payment /> },
            { path: "invoices", element: <Invoices /> },
            { path: "add-stock-multiple", element: <AddMultipleStock /> },
            { path: "items", element: <Products /> },
            { path: "items/summary", element: <ItemSummary /> },
            { path: "categories", element: <Categories /> },
            { path: "sub-categories", element: <SubCategories /> },
            { path: "stock-stats", element: <StockStats /> },
            { path: "raw-material-stock-stats", element: <RMStockStat /> },
            { path: "expense", element: <Expense /> },
            { path: "loans", element: <Loan /> },
            { path: "loans/:loanId", element: <LoanDetail /> },
            { path: "labour", element: <Labour /> },
            { path: "daily-report", element: <DailyReport /> },
            { path: "daily-report/detail", element: <DailyReportDetail /> },
            { path: "report", element: <Report /> },
            { path: "accounts", element: <Accounts /> },
            { path: "accounts/:accountId/log", element: <AccountTransactionLog /> },
            { path: "cash-book", element: <CashPayments /> },
            { path: "calculator", element: <Calculator /> },
            { path: "invoice/:id/:cid", element: <NewBillInvoice /> },
            { path: "companies-report", element: <CompanyReport /> },
            { path: "companies-report", element: <CompanyReport /> },
            { path: "items-report", element: <ItemReport /> },
            { path: "customers-report", element: <CustomersReport /> },
            {
              path: "customer-ledger-report/:id",
              element: <CustomersLegderReport />,
            },
            {
              path: "company-ledger-report/:id",
              element: <CompanyLegderReport />,
            },
            {
              path: "customer-item-summary/:id",
              element: <CustomersItemSummaryReport />,
            },
            {
              path: "company-item-summary/:id",
              element: <CompanyItemSummaryReport />,
            },
            { path: "investors", element: <Investors /> },
            { path: "investments/:id", element: <Investments /> },
            { path: "branches", element: <Branches /> },
            { path: "loan-accounts", element: <LoanAccountUsers /> },
            { path: "discount-log", element: <DiscountLogPage /> },
            {
              path: "discount-log/customer/:customerId",
              element: <DiscountLogPage />,
            },
            {
              path: "discount-log/company/:companyId",
              element: <DiscountLogPage />,
            },
            { path: "stock-qty-log", element: <StockQtyAdjustmentReport /> },
            {
              path: "stock-qty-log/item/:itemId",
              element: <StockQtyAdjustmentReport />,
            },
          ],
        },
        { path: "*", element: <Navigate to="/admin" replace /> },
      ]
    : sessionRole === 2
    ? [
        {
          path: "/branch",
          element: <Layout />,
          children: [
            { path: "", element: <Dashboard /> },
            { path: "companies", element: <Supplier /> },
            { path: "ledger", element: <Ledger /> },
            { path: "customers", element: <Customers /> },
            { path: "receivables", element: <Receivables /> },
            { path: "receivables/:customerId", element: <ReceivableDetail /> },
            { path: "payables", element: <Payables /> },
            { path: "payables/:companyId", element: <PayableDetail /> },
            { path: "cash-payments", element: <CashPayments /> },
            { path: "finance", element: <Finance /> },
            { path: "customers-invoice", element: <CreateInvoice /> },
            { path: "edit-customers-invoice", element: <EditInvoice /> },
            {
              path: "edit-customers-invoice/:invoiceId",
              element: <EditInvoice />,
            },
            { path: "edit-customers-return", element: <EditReturn /> },
            {
              path: "edit-customers-return/:returnId",
              element: <EditReturn />,
            },
            { path: "customers-payments/:id", element: <CustomerPayments /> },
            { path: "company-payments/:id", element: <CompanyPayments /> },
            {
              path: "view-customers-invoice",
              element: <CustomerViewInvoice />,
            },
            { path: "supplier-invoice", element: <SupplierCreateInvoice /> },
            { path: "payments", element: <Payment /> },
            { path: "invoices", element: <Invoices /> },
            { path: "items", element: <Products /> },
            { path: "items/summary", element: <ItemSummary /> },
            { path: "categories", element: <Categories /> },
            { path: "sub-categories", element: <SubCategories /> },
            { path: "add-stock-multiple", element: <AddMultipleStock /> },
            { path: "stock-stats", element: <StockStats /> },
            { path: "raw-material-stock-stats", element: <RMStockStat /> },
            { path: "expense", element: <Expense /> },
            { path: "loans", element: <Loan /> },
            { path: "loans/:loanId", element: <LoanDetail /> },
            { path: "labour", element: <Labour /> },
            { path: "daily-report", element: <DailyReport /> },
            { path: "daily-report/detail", element: <DailyReportDetail /> },
            { path: "report", element: <Report /> },
            { path: "accounts", element: <Accounts /> },
            { path: "accounts/:accountId/log", element: <AccountTransactionLog /> },
            { path: "cash-book", element: <CashPayments /> },
            { path: "calculator", element: <Calculator /> },
            { path: "invoice/:id/:cid", element: <NewBillInvoice /> },
            { path: "companies-report", element: <CompanyReport /> },
            { path: "companies-report", element: <CompanyReport /> },
            { path: "items-report", element: <ItemReport /> },
            { path: "customers-report", element: <CustomersReport /> },
            {
              path: "customer-ledger-report/:id",
              element: <CustomersLegderReport />,
            },

            {
              path: "customer-item-summary/:id",
              element: <CustomersItemSummaryReport />,
            },
            {
              path: "company-ledger-report/:id",
              element: <CompanyLegderReport />,
            },
            {
              path: "company-item-summary/:id",
              element: <CompanyItemSummaryReport />,
            },
            { path: "investors", element: <Investors /> },
            { path: "investments/:id", element: <Investments /> },
            { path: "branches", element: <Branches /> },
            { path: "discount-log", element: <DiscountLogPage /> },
            {
              path: "discount-log/customer/:customerId",
              element: <DiscountLogPage />,
            },
            {
              path: "discount-log/company/:companyId",
              element: <DiscountLogPage />,
            },
            { path: "stock-qty-log", element: <StockQtyAdjustmentReport /> },
            {
              path: "stock-qty-log/item/:itemId",
              element: <StockQtyAdjustmentReport />,
            },
          ],
        },
        { path: "*", element: <Navigate to="/branch" replace /> },
      ]
    : sessionRole === 4
    ? [
        {
          path: "/loan-account",
          element: <Layout />,
          children: [{ path: "", element: <LoanPartyPortal /> }],
        },
        { path: "*", element: <Navigate to="/loan-account" replace /> },
      ]
    : [
        {
          path: "/auth",
          element: <Auth />,
          // children: [{ path: "", element: <Auth /> }],
        },
        { path: "*", element: <Navigate to="/auth" replace /> },
      ]
);

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <Provider store={store}>
      <RouterProvider router={router} />
      <Toaster
        position="top-right"
        reverseOrder={false}
        toastOptions={{
          duration: 3200,
          style: {
            borderRadius: "12px",
            background: "#1A2426",
            color: "#fff",
            fontFamily: "Quicksand, sans-serif",
            fontSize: "14px",
            fontWeight: 600,
            padding: "10px 14px",
            boxShadow: "0 4px 12px rgba(16,69,70,0.18)",
          },
          success: {
            iconTheme: { primary: "#0E9F6E", secondary: "#fff" },
          },
          error: {
            iconTheme: { primary: "#D14343", secondary: "#fff" },
          },
        }}
      />
    </Provider>
  </React.StrictMode>
);
